export function isValidURLForRedirect(url: string): boolean {
  let urlObj;

  try {
    urlObj = new URL(url);
  } catch {
    return false;
  }

  // Reject non-http(s) schemes outright (e.g. javascript:, data:) before any
  // other check - the URL parser will still populate .hostname for these on
  // a "scheme://host" shape, so isLocalHost() below must never be allowed to
  // bypass this.
  if (urlObj.protocol !== 'http:' && urlObj.protocol !== 'https:') {
    return false;
  }

  if (isLocalHost(urlObj)) {
    // Local dev only: allow plain http in addition to https.
    return true;
  }

  return urlObj.protocol === 'https:';
}

// Defense in depth for return_to/redirectTo: both are meant to be plain,
// same-app relative paths (Devise's request.fullpath, or a query param we
// pass straight to navigate()). Resolve the candidate against the current
// origin and check where it ACTUALLY lands, rather than pattern-matching the
// raw string - a string-prefix check (e.g. "starts with / but not //") is
// too easy to get wrong: browsers also treat a leading backslash as a slash
// for special schemes, so "/\evil.com" resolves to https://evil.com despite
// having only one literal "/". Comparing the resolved origin closes that and
// any similar encoding trick at once.
export function isSafeRelativePath(path: string): boolean {
  try {
    return (
      new URL(path, window.location.origin).origin === window.location.origin
    );
  } catch {
    return false;
  }
}

export function isSameDomain(url: string): boolean {
  const urlObj = new URL(url);
  return getURLDomain(window.location) === getURLDomain(urlObj);
}

function isLocalHost(url: URL) {
  return url.hostname === 'my.local' || url.hostname === 'localhost';
}

function getURLDomain(url: any) {
  const urlObj = new URL(url);

  // Handle local environments
  if (isLocalHost(urlObj)) {
    return urlObj.hostname;
  }

  // Parse subdomain out and return only the domain
  const firstDotIndex = urlObj.hostname.indexOf('.');
  return urlObj.hostname.substring(firstDotIndex + 1);
}
